<template>
    <div class="chart-page">
        <v-row>
            <v-col cols="2" sm="2" class="paddintp0"></v-col>
            <v-col cols="8" sm="8" class="paddintp0">
                <div class="switch-group" v-if="subjects">
                    <div class="switch-cust" :key="subject.id" v-for="subject in subjects">
                        <v-switch
                            @change="updateAttemptList(subject)"
                            inset
                            :label="subject.text"
                            :disabled="subject.status"
                            v-model="subject.status"
                            class="opacity-1"
                        ></v-switch>
                    </div>
                </div>
                <div class="switch-group group-2">
                    <div class="check-cust correct-check">
                        <v-checkbox
                            v-model="questionStatus.correct"
                            label="Correct"
                            dense
                            hide-details
                        ></v-checkbox>
                    </div>
                    <div class="check-cust incorrect-check">
                        <v-checkbox
                            v-model="questionStatus.incorrect"
                            label="Incorrect"
                            dense
                            hide-details
                        ></v-checkbox>
                    </div>
                    <div class="check-cust unanswered-check">
                        <v-checkbox
                            v-model="questionStatus.unAnswered"
                            label="Unanswered"
                            dense
                            hide-details
                        ></v-checkbox>
                    </div>
                    <div class="check-cust partiallycorrect-check">
                        <v-checkbox
                            v-model="questionStatus.partiallyCorrect"
                            label="Partially Correct"
                            dense
                            hide-details
                        ></v-checkbox>
                    </div>
                </div>
            </v-col>
            <!-- <v-col cols="2" sm="2" class="paddintp0">
                <div class="chart-top-btn-how">
                    <v-btn class="how-sub-btn" outlined>How This Works</v-btn>
                </div>
            </v-col>-->
        </v-row>
        <v-row>
            <v-col cols="12" sm="12">
                <v-simple-table fixed-header class="simple-header-200">
                    <template v-slot:default>
                        <thead>
                            <tr class="tr-I">
                                <th class="text-center top-btm-br" rowspan="2">Q.No.</th>
                                <th class="text-center top-btm-br" rowspan="2">Your Attempt</th>
                                <th v-if="currentRoute!='response-analysis-practice' " class="text-center top-br" colspan="2">Batch Statistics</th>
                                <th v-if="currentRoute!='response-analysis-practice' " class="text-center top-br" colspan="2">Institute Statistics</th>
                                <th class="text-center top-btm-br" rowspan="2" v-if="!omrDetail || !omrDetail.id">Your Time</th>
                                <th
                                    class="text-center top-btm-br"
                                    rowspan="2"
                                    v-if="!omrDetail || !omrDetail.id"
                                >Average Time for Correct Attempt</th>
                                <th class="text-center top-btm-br" rowspan="2"></th>
                            </tr>
                            <tr class="tr-II" v-if="currentRoute!='response-analysis-practice' ">
                                <th class="text-center btm-br">%C</th>
                                <th class="text-center btm-br">%IC</th>
                                <th class="text-center btm-br">%C</th>
                                <th class="text-center btm-br">%IC</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="ad in attemptDetailsList">
                                <template
                                    v-if="questionStatus[ad.attemptStatus.value] && selectedSubject == ad.subjectId"
                                >
                                    <v-tooltip
                                        bottom
                                        content-class="attempt-details-tooltip"
                                        :key="ad.id"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <tr
                                                @click="getQuestion(ad)"
                                                :key="ad.id"
                                                v-on="on"
                                            >
                                                <td class="text-center">{{ ad.questionNo }}</td>
                                                <td class="text-center">
                                                    <div
                                                        :class="ad.attemptStatus.class"
                                                    >{{ ad.attemptStatus.text }}</div>
                                                </td>
                                                <td class="text-center" v-if="currentRoute!='response-analysis-practice' ">{{ ad.batchCorrectPerc }}</td>
                                                <td class="text-center" v-if="currentRoute!='response-analysis-practice' ">{{ ad.batchIncorrectPerc }}</td>
                                                <td
                                                    class="text-center"
                                                 v-if="currentRoute!='response-analysis-practice' ">{{ ad.instituteCorrectPerc }}</td>
                                                <td
                                                    class="text-center"
                                                 v-if="currentRoute!='response-analysis-practice' ">{{ ad.instituteIncorrectPerc }}</td>
                                                <td class="text-center" v-if="!omrDetail || !omrDetail.id">{{ ad.timeSpent }}</td>
                                                <td class="text-center" v-if="!omrDetail || !omrDetail.id">{{ ad.avgTimeSpent }}</td>
                                                <td class="text-center">
                                                    <div
                                                        v-if="ad.isOvertime && (!omrDetail || !omrDetail.id)"
                                                        :class="ad.attemptStatus.class"
                                                    >Overtime Attempt</div>
                                                </td>
                                            </tr>
                                        </template>
                                        Click to View Question
                                    </v-tooltip>
                                </template>
                            </template>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="6" sm="6" class="paddintp0">
                <div class="text-left btm-text">
                    <label>%C:</label> Percentage of students who got the question correct
                </div>
            </v-col>
            <v-col cols="6" sm="6" class="paddintp0">
                <div class="text-right btm-text">
                    <label>%IC:</label> Percentage of students who got the question incorrect
                </div>
            </v-col>
        </v-row>
        <AlertBox
            :width="modalwidth"
            :onClose="onClose"
            :component="cComponent"
            :status="status"
            :data="alertBoxData"
        />
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
import momentDuration from "moment-duration-format";
momentDuration(moment);

export default {
    name: "DetailsAttemptsTime",
    mounted() {
        this.currentRoute=this.$route.name;
        this.questionTypes = this.QUE_TYPES;
        this.getSubjects();
        this.getAttemptDetails();
        this.getOmrDetails()
    },
    props: ["studentId", "studentTestId"],

    data() {
        return {
            cComponent: "",
            alertBoxData: {},
			student_id:0,
            status: false,
            modalwidth: "70%",
            questionTypes: {},
            subjects: [],
            selectedSubject: null,
            attemptStatus: {
                PC: {
                    value: "partiallyCorrect",
                    text: "Partially Correct",
                    class: "partiallycorrect",
                },
                IC: {
                    value: "incorrect",
                    text: "Incorrect",
                    class: "incorrect",
                },
                C: { value: "correct", text: "Correct", class: "correct" },
                NA: {
                    value: "unAnswered",
                    text: "Unanswered",
                    class: "unanswered",
                },
            },
            attemptDetailsList: [],
            questionStatus: {
                correct: true,
                incorrect: true,
                unAnswered: true,
                partiallyCorrect: true,
            },
            currentRoute:'',
            omrDetail: null
        };
    },
    computed: {
        ...mapState("userStore", ["user"]),
    },

    methods: {
        ...mapActions({
            getDetailsOfAttempList: "resultStore/getDetailsOfAttempList",
            getTestSubjects: "resultStore/getTestSubjects",
            getOmrDetail: "testStore/getOmrDetail",
            getQuestionDetails: "resultStore/getQuestionDetails",
        }),
        getQuestion(question) {
            let postData = {
                test_detail_id: question.testDetailId,
				studentId: parseInt(this.studentId)
            };
            this.$root.showLoader = true;
            this.getQuestionDetails(postData)
                .then((response) => {
                    question.question_details = response.question_details;
                    let processedQuestion = this.processQuestion(question);
                    question.currentQuestion = processedQuestion;
                    question.currentQuestion.questionNo = question.questionNo;
                    question.currentQuestion.isBonus = question.isBonus;
                    this.showQuestionDetails(question);
                    this.$root.showLoader = false;
                })
                .catch((err) => {
                    this.$toasted.error(
                        "Error getting question Details. Please try again"
                    );
                    this.$root.showLoader = false;
                });
        },
        showQuestionDetails(question) {
            this.cComponent = "components/student/QuestionDetailPreview";
            this.alertBoxData = {
                currentQuestion: question.currentQuestion,
                showAnswerField: true,
            };
            this.modalwidth = "70%";
            this.status = true;
            this.$forceUpdate();
        },
        onClose(data) {
            this.status = data.status;
        },
        updateAttemptList(subject) {
            this.selectedSubject = subject.id;
            this.subjects.map((s) => {
                if (s.id != subject.id) {
                    s.status = false;
                }
            });
        },
        getSubjects() {
            let test_id = this.$route.params.test_id;
            let reqData = { test_id, student_id: this.studentId };
            this.$root.showLoader = true;
            this.getTestSubjects(reqData)
                .then((response) => {
                    response.forEach((subject, idx) => {
                        let subjectObj = {
                            id: subject.id,
                            text: subject.title,
                            status: false,
                        };
                        if (idx == 0) {
                            subjectObj.status = true;
                            this.selectedSubject = subject.id;
                        }
                        this.$set(this.subjects, idx, subjectObj);
                    });
                    this.$forceUpdate();
                })
                .catch((err) => {
                    this.$root.showLoader = false;
                });
        },
        getAttemptDetails() {
            let testInstituteId = this.$route.params.test_institute_id;
            let reqData = {
                test_institute_id: parseInt(testInstituteId),
                student_id: parseInt(this.studentId),
                student_test_id: this.studentTestId
            };
            this.$root.showLoader = true;
            this.getDetailsOfAttempList(reqData)
                .then((response) => {
                    this.processAttemptDetailsData(response.list);
                })
                .catch((err) => {
                    this.$root.showLoader = false;
                });
        },
        getTimeSpentInRequiredFormat(timeSpent) {
            let timeObj = moment.duration(timeSpent, "seconds");
            let timeSpentString = timeObj.format("HH:mm:ss", { trim: false });
            return timeSpentString;
        },
        processAttemptDetailsData(list) {
            let attemptDetails = [];
            for (let i = 0; i < list.length; i++) {
                const questionData = list[i];
                let questionObj = {};
                questionObj.yourAnswer = questionData.your_answer;
                questionObj.testDetailId = questionData.test_detail_id;
                questionObj.questionNo = questionData.index;
                questionObj.id = questionData.question_id;
                questionObj.isBonus = questionData.is_bonus;
                questionObj.subjectId =
                    questionData.question_details.datatype.parent;
                questionObj.chapterId =
                    questionData.question_details.datatype.id;
                questionObj.questionNo = questionData.index;
                questionObj.timeSpent = this.getTimeSpentInRequiredFormat(
                    questionData.your_time_in_sec
                );
                questionObj.avgTimeSpent = this.getTimeSpentInRequiredFormat(
                    questionData.average_time_in_sec
                );
                questionObj.isOvertime =
                    parseInt(questionData.your_time_in_sec) >
                    parseInt(questionData.average_time_in_sec)
                        ? true
                        : false;
                questionObj.batchCorrectPerc = questionData.batch_correct_per;
                questionObj.batchIncorrectPerc =
                    questionData.batch_incorrect_per;
                questionObj.instituteCorrectPerc =
                    questionData.institute_correct_per;
                questionObj.instituteIncorrectPerc =
                    questionData.institute_incorrect_per;
                questionObj.attemptStatus = this.attemptStatus[
                    questionData.your_attempt
                ];
                attemptDetails.push(questionObj);
            }
            this.$root.showLoader = false;
            this.attemptDetailsList = attemptDetails;
        },
        processQuestion(questionData) {
            let q = questionData.question_details; // current question in loop
            q.user_selected_answer = questionData.yourAnswer;
            let questionTypeId = q.question_type;
            questionTypeId =
                questionTypeId == this.questionTypes.COMPREHENSION ||
                questionTypeId == this.questionTypes.TC
                    ? q.subtype.id ?q.subtype.id :q.subtype
                    : q.question_type;
            let currentQuestion = {};
            currentQuestion = this.generateQuestionObject(questionTypeId, q);
        currentQuestion.subtype = q.subtype ? q.subtype.id ?q.subtype.id :q.subtype:'';
            if (
                q.question_type == this.questionTypes.COMPREHENSION ||
                q.question_type == this.questionTypes.TC
            ) {
                currentQuestion.passage = q.passage;
            }
            currentQuestion = this.getCurrentQuestionCommonKeys(
                currentQuestion,
                q
            );
            return currentQuestion;
        },

        getCurrentQuestionCommonKeys(currentQuestion, q) {
            currentQuestion.id = q.id;
            currentQuestion.questionNo = q.index;
            currentQuestion.question_text = q.question_text;
            currentQuestion.question_type = q.question_type;
            currentQuestion.questionType = { id: q.question_type };
            currentQuestion.parent_id = q.parent_id;
            currentQuestion.section_id = q.section_id;
            currentQuestion.test_detail_id = q.test_detail_id;
            currentQuestion.correct_marks = q.marks;
            currentQuestion.negative_marks = q.negative_marks;
            currentQuestion.partial_marking = q.partial_marking;
            currentQuestion.solution = q.solution;
            currentQuestion.hints = q.hints;
            currentQuestion.isBonus = q.is_bonus;
            currentQuestion.userSelectedAnswer = q.user_selected_answer;
            currentQuestion.status = this.questionStatus.INITIAL; // "status" along with "isAnswered" will be used for loading legends & pallet info
            currentQuestion.isAnswered = false; // to know if the current question is answered.
            currentQuestion.disabled = true;
            currentQuestion.ansStatus = this.PAST_QUESTION_STATUS.NOT_ATTEMPTED;
            let om = q.obtained_mark ? q.obtained_mark : 0;
            currentQuestion.obtained_mark = om;
            currentQuestion.subType = q.subtype;
            let marks = q.marks;
            // if (
            //     currentQuestion.questions &&
            //     (currentQuestion.question_type == this.questionTypes.TC ||
            //         currentQuestion.question_type ==
            //             this.questionTypes.COMPREHENSION)
            // ) {
            //     marks = marks * currentQuestion.questions.length;
            // }

            if (q.user_selected_answer) {
                let answer = q.user_selected_answer;
                currentQuestion.isAnswered = answer.answer ? true : false;
                currentQuestion.status = answer.status;
            }
            if (om == marks) {
                currentQuestion.ansStatus = this.PAST_QUESTION_STATUS.CORRECT;
            } else if (om > 0 && om < marks) {
                currentQuestion.ansStatus = this.PAST_QUESTION_STATUS.PARTIALLY_CORRECT;
            } else if (currentQuestion.isAnswered && om < 1) {
                currentQuestion.ansStatus = this.PAST_QUESTION_STATUS.INCORRECT;
            }

            return currentQuestion;
        },
        getCQRType1(type, q) {
            let responseData = {
                options: [],
                yourAnswer: "",
                correctAnswer: "",
            };
            let correctOptions = _.cloneDeep(q.options);
            let correctAnswer = [];
            let yourAnswer = [];
            let options = q.options.map((o) => {
                return { ...o, ...{ correct_answer: false } };
            });

            correctOptions.forEach((o) => {
                if (parseInt(o.correct_answer)) {
                    correctAnswer.push(o.index);
                }
            });

            if (q.user_selected_answer) {
                let option = null;
                let answer = q.user_selected_answer;
                if (answer.answer) {
                    let switchType = 1;
                    if (
                        this.questionTypes.ASSERTION_REASON == type ||
                        this.questionTypes.SINGLE_CORRECT == type ||
                        this.questionTypes.COMPREHENSION_2Q_SA == type ||
                        this.questionTypes.COMPREHENSION_2Q_MM == type ||
                        this.questionTypes.COMPREHENSION_3Q_SA == type ||
                        this.questionTypes.TC_2Q_SA == type ||
                        this.questionTypes.TC_3Q_SA == type
                    ) {
                        switchType = 1;
                    } else {
                        switchType = 2;
                    }
                    switch (switchType) {
                        case 1:
                            option = options.find(
                                (o) => o.id == answer.answer.option_id
                            );
                            if (option) {
                                yourAnswer.push(option.index);
                                option.correct_answer = true;
                            }
                            break;

                        case 2:
                            answer.answer.option_id.map((a) => {
                                option = options.find((o) => o.id == a);
                                if (option) {
                                    yourAnswer.push(option.index);
                                    option.correct_answer = true;
                                }
                            });
                            break;
                    } // end of switch
                }
            }

            responseData.options = options;
            responseData.yourAnswer = yourAnswer.join(", ");
            responseData.correctAnswer = correctAnswer.join(", ");
            return responseData;
        },
        getCQRType2(q) {
            let responseData = {
                yourAnswer: "",
                correctAnswer: q && q.correct_answer ? q.correct_answer.split('##') : '',
            };
            if (
                    responseData.correctAnswer.length
                ) {
                    responseData.correctAnswer = responseData.correctAnswer.join(
                        ' - '
                    );
                }
            if (q.user_selected_answer) {
                let answer = q.user_selected_answer;
                let yourAnswer = answer.answer
                    ? parseFloat(answer.answer)
                    : null;
                responseData.yourAnswer = yourAnswer;
            }

            return responseData;
        },
        generateQuestionObject(typeId, q) {
            let type = "";
            type = this.getQuestionType(typeId);
            let currentQuestion = {};
            currentQuestion = this.getCurrentQuestionCommonKeys(
                currentQuestion,
                q
            );
            let cqr = null;
            switch (type) {
                case 1:
                    // cqr - currentQuestionResult
                    cqr = this.getCQRType1(typeId, q);
                    currentQuestion.options = cqr.options;
                    currentQuestion.yourAnswer = cqr.yourAnswer;
                    currentQuestion.correctAnswer = cqr.correctAnswer;
                    break;
                case 2:
                    cqr = this.getCQRType2(q);
                    currentQuestion.correct_answer = cqr.yourAnswer;
                    currentQuestion.yourAnswer = cqr.yourAnswer;
                    currentQuestion.correctAnswer = cqr.correctAnswer;
                    break;
                case 3:
                    cqr = this.separateOptions(q, 1);
                    currentQuestion.options_abc = cqr.options_abc;
                    currentQuestion.options_pqr = cqr.options_pqr;
                    currentQuestion.yourAnswer = cqr.yourAnswer;
                    currentQuestion.correctAnswer = cqr.correctAnswer;

                    break;
                case 4:
                    cqr = this.separateOptions(q, 2);
                    currentQuestion.options_abc = cqr.options_abc;
                    currentQuestion.options_pqr = cqr.options_pqr;
                    currentQuestion.options = cqr.op;
                    currentQuestion.yourAnswer = cqr.yourAnswer;
                    currentQuestion.correctAnswer = cqr.correctAnswer;

                    break;
                case 6:
                    cqr = this.getCQRType2(q);
                    currentQuestion.correct_answer = cqr.yourAnswer;
                    currentQuestion.yourAnswer = cqr.yourAnswer;
                    currentQuestion.correctAnswer = cqr.correctAnswer;
                    break;
            }
            return currentQuestion;
        },
        getQuestionType(id) {
            if (
                id == this.questionTypes.ASSERTION_REASON ||
                id == this.questionTypes.MULTIPLE_CORRECT ||
                id == this.questionTypes.SINGLE_CORRECT ||
                id == this.questionTypes.COMPREHENSION_2Q_SA ||
                id == this.questionTypes.COMPREHENSION_2Q_MM ||
                id == this.questionTypes.COMPREHENSION_2Q_MA ||
                id == this.questionTypes.COMPREHENSION_3Q_SA ||
                id == this.questionTypes.COMPREHENSION_3Q_MA ||
                id == this.questionTypes.TC_2Q_SA ||
                id == this.questionTypes.TC_3Q_SA
            ) {
                return 1;
            } else if (id == this.questionTypes.INTEGER) {
                return 2;
            } else if (id == this.questionTypes.MATRIX_MATCH) {
                return 3;
            } else if (id == this.questionTypes.MATRIX_MATCH_OPTION) {
                return 4;
            } else if (
                id == this.questionTypes.COMPREHENSION ||
                id == this.questionTypes.TC
            ) {
                return 5;
            } else if (id == this.questionTypes.SUBJECTIVE ||
                        id == this.questionTypes.COMPREHENSION_2Q_NU || id == this.questionTypes.SUBJECTIVEINTEGER ) {
                return 6;
            }
        },
        getSubjectiveAnswers(answer, q) {
            let separatedAnswer = {
                startValue: null,
                endValue: null,
            };
            if (q.user_selected_answer) {
                let answer = q.user_selected_answer;
                separatedAnswer.startValue = answer.answer
                    ? parseInt(answer.answer.startValue)
                    : null;
                separatedAnswer.endValue = answer.answer
                    ? parseInt(answer.answer.endValue)
                    : null;
            }
            return separatedAnswer;
        },
        separateVals(value) {
                if (value) {
                    value = value.split('##');
                    let valueToReturn = [];
                    value.map((v) => {
                        if (v.trim() > '') {
                            valueToReturn.push(v);
                        }
                    });
                    return valueToReturn.join(', ');
                } else {
                    return '';
                }
            },

        separateOptions(q, type) {
            let options = q.options;
            let op = [];
            let options_abc = [];
            let options_pqr = [];

            let correctAnswer = [];
            let yourAnswer = [];

            options.forEach((option) => {
                // separate options: options (op), options_abc, options_pqr
                if (option.column == 1) {
                    option.correct_answer = option.correct_answer
                        ? option.correct_answer
                        : "";
                    options_abc.push(option);
                } else if (option.column == 2) options_pqr.push(option);
                else {
                    option.correct_answer = option.correct_answer
                        ? option.correct_answer
                        : false;
                    op.push(option);
                }
            });

            // get correct answer
            if (type == 2) {
                // matrix match options
                op.forEach((o, idx) => {
                    if (parseInt(o.correct_answer)) {
                        correctAnswer.push(o.index);
                        op[idx].correct_answer = false;
                    }
                });
            }
            if (type == 1) {
                // matrix match
                options_abc.forEach((o, idx) => {
                    if (o.correct_answer > "") {
                        correctAnswer.push({
                            index: o.index,
                            value: o.correct_answer,
                        });
                        options_abc[idx].correct_answer = "";
                    }
                });
            }

            if (type == 1) {
                // type = 1 : matrix match
                if (q.user_selected_answer) {
                    let answer = q.user_selected_answer;
                    if (answer.answer) {
                        answer.answer.map((a) => {
                            let option = options_abc.find(
                                (o) => o.id == a.option_id
                            );
                            if (option) {
                                yourAnswer.push({
                                    index: option.index,
                                    value: a.value,
                                });
                                option.correct_answer = a.value;
                            }
                        });
                    }
                }
                let ya = yourAnswer.map((answer) => {
                    let ans = answer.index + ": " + this.separateVals(answer.value);
                    return ans;
                });
                ya = ya.join(' | ');
                let ca = correctAnswer.map((answer) => {
                    let ans = answer.index + ": " + this.separateVals(answer.value);
                    return ans;
                });
                ca = ca.join(' | ');
                yourAnswer = ya;
                correctAnswer = ca;
            } else if (type == 2) {
                // type = 2 : matrix match options
                if (q.user_selected_answer) {
                    let answer = q.user_selected_answer;
                    if (answer.answer) {
                        let option = op.find(
                            (o) => o.id == answer.answer.option_id
                        );
                        if (option) {
                            yourAnswer.push(option.index);
                            option.correct_answer = true;
                        }
                    }
                }
                yourAnswer = yourAnswer.join(", ");
                correctAnswer = correctAnswer.join(", ");
            }

            return {
                op,
                options_abc,
                options_pqr,
                yourAnswer,
                correctAnswer,
            };
        },
        getOmrDetails(){
            const {test_id, student_id} = this.$route.params
            const reqData = {
                test_id,
                student_id
            }

            this.getOmrDetail(reqData)
                .then(response=>{
                    this.omrDetail = response
                })
                .catch(err=>{

                })
        }
    },
    watch: {},
};
</script>
